<div [style.visibility]="uploading && progress > 0 ? 'visible' : 'hidden'" class="progress-bar">
  <mat-label>{{ progress }}%</mat-label>
  <mat-progress-bar mode="determinate" [value]="progress"></mat-progress-bar>
</div>
